import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';

const BASE_URL = `${runtimeEnv('B2B_API_BASE_URL')}/admin-api/v3/invoice-seal-signature`;

const sealSignatureService = {
  async getInvoiceSealSignature() {
    try {
      const response = await requestInstance.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Error fetching invoice seal/signature:', error);
      throw error;
    }
  },

  async updateInvoiceSealSignature(formData) {
    try {
      const response = await requestInstance.put(BASE_URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating invoice seal/signature:', error);
      throw error;
    }
  },
};

export default sealSignatureService;
